import { render, staticRenderFns } from "./TitleComponent.vue?vue&type=template&id=048b1c98&scoped=true"
import script from "./TitleComponent.vue?vue&type=script&lang=js"
export * from "./TitleComponent.vue?vue&type=script&lang=js"
import style0 from "./TitleComponent.vue?vue&type=style&index=0&id=048b1c98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048b1c98",
  null
  
)

export default component.exports